import {
  AnswerTypes,
  ChangeTreeSelectChoicesParamsTypes,
  ChoiceTypes,
  SurveyOutlineTypes,
} from 'types/survey';
import {
  CHANGE_ANSWER,
  CHANGE_TREE_SELECT_CHOICES,
  FAILURE_FETCH_INITIAL_SURVEY_STEP,
  FAILURE_FETCH_SURVEY_STEP,
  FAILURE_FETCH_TREE_SELECT_CHOICES,
  FAILURE_POST_ANSWERS,
  FAILURE_POST_COMPLETE_SURVEY,
  HAS_INVALID_ANSWER,
  REQUEST_CHANGE_CURRENT_SURVEY_STEP,
  REQUEST_FETCH_INITIAL_SURVEY_STEP,
  REQUEST_FETCH_SURVEY_STEP,
  REQUEST_FETCH_TREE_SELECT_CHOICES,
  REQUEST_POST_ANSWERS,
  REQUEST_POST_COMPLETE_SURVEY,
  RESET_ERROR_TOAST,
  RESET_KEY_BIND_EXPLANATION,
  RESET_TREE_SELECT_CHOICES,
  SLIDE_NEXT_STEP,
  SLIDE_PREV_STEP,
  SUCCESS_CHANGE_CURRENT_SURVEY_STEP,
  SUCCESS_FETCH_INITIAL_SURVEY_STEP,
  SUCCESS_FETCH_SURVEY_STEP,
  SUCCESS_FETCH_TREE_SELECT_CHOICES,
  SUCCESS_POST_ANSWERS,
  SUCCESS_POST_COMPLETE_SURVEY,
  TOGGLE_TREE_SELECT_DIVE_MODAL,
  TOGGLE_TREE_SELECT_SEARCH_MODAL,
  VERIFY_ANSWER,
} from '../actionTypes';

export const requestFetchInitialSurveyStep = () => {
  return {
    type: REQUEST_FETCH_INITIAL_SURVEY_STEP,
  };
};

export const successFetchInitialSurveyStep = (
  payload: SurveyOutlineTypes,
  deviceVariant: string,
) => {
  return {
    type: SUCCESS_FETCH_INITIAL_SURVEY_STEP,
    payload,
    deviceVariant,
  };
};

export const failureFetchInitialSurveyStep = () => ({
  type: FAILURE_FETCH_INITIAL_SURVEY_STEP,
});

export const requestChangeCurrentSurveyStep = (currentStepNumber: number) => {
  return {
    type: REQUEST_CHANGE_CURRENT_SURVEY_STEP,
    currentStepNumber,
  };
};

export const successChangeCurrentSurveyStep = (currentStepNumber: number) => ({
  type: SUCCESS_CHANGE_CURRENT_SURVEY_STEP,
  currentStepNumber,
});

export const requestFetchSurveyStep = () => ({
  type: REQUEST_FETCH_SURVEY_STEP,
});

export const successFetchSurveyStep = (
  currentStepNumber: number,
  payload: SurveyOutlineTypes,
  deviceVariant: string,
) => ({
  type: SUCCESS_FETCH_SURVEY_STEP,
  currentStepNumber,
  payload,
  deviceVariant,
});

export const failureFetchSurveyStep = () => ({
  type: FAILURE_FETCH_SURVEY_STEP,
});

export const toggleTreeSelectSearchModal = (flag: boolean) => ({
  type: TOGGLE_TREE_SELECT_SEARCH_MODAL,
  flag,
});

export const toggleTreeSelectDiveModal = (flag: boolean) => ({
  type: TOGGLE_TREE_SELECT_DIVE_MODAL,
  flag,
});

export const changeTreeSelectChoices = (params: ChangeTreeSelectChoicesParamsTypes) => ({
  type: CHANGE_TREE_SELECT_CHOICES,
  params,
});

export const resetTreeSelectChoices = (surveyStepItemId: string) => ({
  type: RESET_TREE_SELECT_CHOICES,
  surveyStepItemId,
});

export const requestFetchTreeSelectChoices = () => ({
  type: REQUEST_FETCH_TREE_SELECT_CHOICES,
});

export const successFetchTreeSelectChoices = (
  surveyStepItemId: string,
  payload: ChoiceTypes[],
) => ({
  type: SUCCESS_FETCH_TREE_SELECT_CHOICES,
  surveyStepItemId,
  payload,
});

export const failureFetchTreeSelectChoices = () => ({
  type: FAILURE_FETCH_TREE_SELECT_CHOICES,
});

export const changeAnswer = (answer: AnswerTypes) => ({
  type: CHANGE_ANSWER,
  answer,
});

export const verifyAnswer = () => ({
  type: VERIFY_ANSWER,
});

export const hasInvalidAnswer = () => ({
  type: HAS_INVALID_ANSWER,
});

export const resetErrorToast = () => ({
  type: RESET_ERROR_TOAST,
});

export const requestPostAnswers = () => ({
  type: REQUEST_POST_ANSWERS,
});

export const successPostAnswers = (
  currentStepNumber: number,
  payload: SurveyOutlineTypes,
  deviceVariant: string,
) => ({
  type: SUCCESS_POST_ANSWERS,
  currentStepNumber,
  payload,
  deviceVariant,
});

export const failurePostAnswers = () => ({
  type: FAILURE_POST_ANSWERS,
});

export const slideNextStep = () => ({
  type: SLIDE_NEXT_STEP,
});

export const slidePrevStep = () => ({
  type: SLIDE_PREV_STEP,
});

export const resetKeyBindExplanation = () => ({
  type: RESET_KEY_BIND_EXPLANATION,
});

export const requestPostCompleteSurvey = () => ({
  type: REQUEST_POST_COMPLETE_SURVEY,
});

export const successPostCompleteSurvey = () => ({
  type: SUCCESS_POST_COMPLETE_SURVEY,
});

export const failurePostCompleteSurvey = () => ({
  type: FAILURE_POST_COMPLETE_SURVEY,
});
